import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConfirmMessageComponent } from './presentationals/messages/confirm-message/confirm-message.component';
import { ErrorMessageComponent } from './presentationals/messages/error-message/error-message.component';
import { SuccessMessageComponent } from './presentationals/messages/success-message/success-message.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { LoaderComponent } from './presentationals/loader/loader.component';
import { SiteTemplateComponent } from './containers/site-template/site-template.component';
import { RouterModule } from '@angular/router';
import { NavListItemComponent } from './presentationals/nav-list-item/nav-list-item.component';
import { DateTimeFilterComponent } from './presentationals/grid-table/filters/date-time-filter/date-time-filter.component';
import { GuidFilterComponent } from './presentationals/grid-table/filters/guid-filter/guid-filter.component';
import { NumberFilterComponent } from './presentationals/grid-table/filters/number-filter/number-filter.component';
import { StringFilterComponent } from './presentationals/grid-table/filters/string-filter/string-filter.component';
import { BoolFilterComponent } from './presentationals/grid-table/filters/bool-filter/bool-filter.component';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { SearchTextComponent } from './presentationals/grid-table/search-text/search-text.component';
import { FilterButtonComponent } from './presentationals/grid-table/filter-button/filter-button.component';
import { MatTabsModule } from '@angular/material/tabs';
import { LanguageSelectorComponent } from './presentationals/language-selector/language-selector.component';
import { ImageInputComponent } from './presentationals/image-input/image-input.component';
import { YearMonthCalendarComponent } from './presentationals/year-month-calendar/year-month-calendar.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PostalCodeComponent } from './presentationals/postal-code/postal-code.component';
import { RoundPipe } from '../core/pipes/round.pipe';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDateFormats, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { SearchDeactivatedComponent } from './presentationals/grid-table/search-deactivated/search-deactivated.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { SafeHtmlPipe } from '../core/pipes/safe-html.pipe';
import { PasswordStrengthComponent } from './presentationals/password-strength/password-strength.component';
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { ModuleFilterComponent } from './presentationals/grid-table/filters/module-filter/module-filter.component';
import { AvatarComponent } from './presentationals/avatar/avatar.component';
import { StripHtmlPipe } from '../core/pipes/strip-html.pipe';
import { HelpIconComponent } from './presentationals/help-icon/help-icon.component';
import { HelpTextDialogComponent } from './presentationals/help-text-dialog/help-text-dialog.component';
import { InstallAppPromptComponent } from './presentationals/install-app-prompt/install-app-prompt.component';
import { AppFooterComponent } from './containers/app-footer/app-footer.component';
import { MatTabsComponent } from './presentationals/mat-tabs/mat-tabs.component';

export const customDateFormat: MatDateFormats = {
  parse: {
    dateInput: 'DD.MM.YYYY'
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};

const sharedModules = [
  CommonModule,
  RouterModule,
  TranslateModule,
  ReactiveFormsModule,
  MatSnackBarModule,
  MatButtonModule,
  MatCheckboxModule,
  MatCardModule,
  MatExpansionModule,
  MatInputModule,
  MatIconModule,
  MatTooltipModule,
  MatListModule,
  MatMenuModule,
  MatToolbarModule,
  MatSidenavModule,
  MatSelectModule,
  MatDatepickerModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatTabsModule,
  MatDialogModule,
  MatSlideToggleModule,
  MatMomentDateModule,
  MatAutocompleteModule,
  MatChipsModule,
  MatProgressBarModule
]

const sharedComponents = [
  LoaderComponent,
  SiteTemplateComponent,
  LanguageSelectorComponent,
  // Grid table
  DateTimeFilterComponent,
  GuidFilterComponent,
  NumberFilterComponent,
  StringFilterComponent,
  BoolFilterComponent,
  SearchTextComponent,
  FilterButtonComponent,
  ImageInputComponent,
  YearMonthCalendarComponent,
  SearchDeactivatedComponent,
  PostalCodeComponent,
  NavListItemComponent,
  PasswordStrengthComponent,
  ModuleFilterComponent,
  AvatarComponent,
  HelpIconComponent,
  HelpTextDialogComponent,
  MatTabsComponent
];

const customPipes = [
  RoundPipe,
  SafeHtmlPipe,
  StripHtmlPipe
];

@NgModule({
  declarations: [
    sharedComponents,
    customPipes,
    ConfirmMessageComponent,
    ErrorMessageComponent,
    SuccessMessageComponent,
    PasswordStrengthComponent,
    ModuleFilterComponent,
    InstallAppPromptComponent,
    AppFooterComponent,
  ],
  imports: [
    sharedModules
  ],
  exports: [
    sharedModules,
    sharedComponents,
    customPipes
  ],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: customDateFormat },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
  ]
})
export class SharedModule {
  // This is causing the Locale_ID to be initialized before the APP_INitializer
  //constructor(private readonly languageService: LanguageService,
  //  private readonly dateAdapter: DateAdapter<Date>) {
  //  /*this.languageService.currentLanguage$
  //    .subscribe(currentLanguage => {
  //      this.dateAdapter.setLocale(currentLanguage);
  //    });*/
  //}
}
